import { useBorrowerContext } from "../../../../store/borrower-details";
import styles from "../../../../BorrowerDetails.module.css";
import { Link, useParams } from "react-router-dom";
import { BiEdit } from "react-icons/bi";
import { VscNewFolder } from "react-icons/vsc";
import { AiOutlineDelete } from "react-icons/ai";
import { IoIosCopy } from "react-icons/io";
// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CoapplicantDocumentsModal from "../../../Modals/CoapplicantDocumentsModal";
import axios from "axios";
import { url } from "../../../../../../../App";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import { AiOutlineFolderOpen } from "react-icons/ai";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
} from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import Tooltip from "@mui/material/Tooltip";
import ReplayIcon from "@mui/icons-material/Replay";
import { v4 as uuidv4 } from "uuid";

const CoapplicantDetails = ({ openLoader, closeLoader, permissions }) => {
  const { borrowerData, updateBorrowerData } = useBorrowerContext();
  console.log(borrowerData);
  const fetchedLoanDetails = borrowerData.loan;
  const { loanid } = useParams();
  const latestLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  console.log(latestLoan);
  // const fetchedBorrowerDetails = borrowerData.borrower;
  const coapplicant = borrowerData?.coapplicant?.filter(
    (item) => String(item.coapplicant_loan_id) === String(loanid)
  );
  console.log(coapplicant);
  // const navigate = useNavigate();
  const [coapplicantModal, setCoapplicantModal] = useState(false);
  const [coapplicantDetails, setCoapplicantDetails] = useState({});
  const [showInputBox, setShowInputBox] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [duplicateData, setDuplicateData] = useState("");
  const [userMobile, setuserMobile] = useState("");
  const [userName, setuserName] = useState("");
  const [statusModal, setstatusModal] = useState(false);
  const [coapplicantPhoneNumber, setCoapplicantPhoneNumber] = useState("");
  const [coapplicantName, setCoapplicantName] = useState("");
  // eslint-disable-next-line
  const [otp, setOtp] = useState(false);
  const [otpVerification, setOtpVerification] = useState(false);
  const [coapplicantId, setCoapplicantId] = useState(null);
  const [vendorCalling, setVendorCalling] = useState(null);

  const [modalVisible1, setModalVisible1] = useState(false);
  const [leadNumbers, setLeadNumbers] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [currentLoan, setCurrentLoan] = useState(null);
  const [isDisbursed, setIsDisbursed] = useState(false);
  const email = Cookies.get("Email");

  useEffect(() => {
    if (loanid) {
      console.log(latestLoan)
      setIsDisbursed(latestLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [latestLoan]);

  const openCoapplicantDocsModal = (data) => {
    setCoapplicantDetails(data);
    setCoapplicantModal(true);
  };
  const [ip, setIp] = useState("");
  const fetch = async () => {
    try {
      const { data } = await axios.get("https://api.ipify.org");
      setIp(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch();
    axios
      .post(url + "/user/getsingle", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        useremail: Cookies.get("Email"),
      })
      .then((res) => {
        console.log(res);
        setuserMobile(res.data[0].staff_mobile);
        setuserName(res.data[0].staff_name);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(url + "/vendor/view", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      })
      .then((res) => {
        if (res.data.auth && res.data.message.vendorCalling) {
          console.log(res.data.message);
          setVendorCalling(res.data.message.vendorCalling);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to fetch vendor calling data.");
      });
  }, []);

  useEffect(() => {
    const coapplicantData = coapplicant.find(
      (item) => item.coapplicant_id === coapplicantId
    );
    // console.log(coapplicantData, "coapplicantData")

    if (otpVerification) {
      openLoader();
      // console.log("OTP verified, calling API...");
      axios
        .post(url + "/coapplicant/regenerate/credit/score", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          coapplicant_name: coapplicantName,
          coapplicant_mobile: coapplicantPhoneNumber,
          coapplicant_panno: coapplicantData.coapplicant_panno,
          coapplicant_aadharno: coapplicantData.coapplicant_aadharno,
          coapplicant_voterno: coapplicantData.coapplicant_voterno,
          coapplicant_dob: coapplicantData.coapplicant_dob,
          coapplicant_residence_address:
            coapplicantData.coapplicant_residence_address,
          coapplicant_pincode: coapplicantData.coapplicant_pincode,
          coapplicant_locality: coapplicantData.coapplicant_locality,
          coapplicant_city: coapplicantData.coapplicant_city,
          coapplicant_state: coapplicantData.coapplicant_state,
          coapplicant_gender: coapplicantData.coapplicant_gender,
          coapplicant_id: coapplicantData.coapplicant_id,
          coapplicant_borrower_uniqueno:
            coapplicantData.coapplicant_borrower_uniqueno,
          coapplicant_loan_id: coapplicantData.coapplicant_loan_id,
          otp_status: "verified",
        })
        .then((res) => {
          console.log(res);
          if (res.data.auth) {
            closeLoader();
            toast.success(res.data.message);
            setstatusModal(false);
            setCoapplicantPhoneNumber("");
            axios
              .post(url + "/borrower/borrowertoalldetails", {
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
                borrower_uniqueno: localStorage.getItem("uniqueID"),
              })
              .then((res) => {
                updateBorrowerData((prevState) => ({
                  ...prevState,
                  coapplicant: res.data.message.coapplicant,
                }));
              })
              .catch((error) => {
                console.log("Error updating borrower details:", error);
                toast.error("Failed to update borrower details.");
              })
              .finally(() => {
                closeLoader();
              });
          } else {
            closeLoader();
            toast.error(res.data.message);
            setstatusModal(false);
            setCoapplicantPhoneNumber("");
          }
        })
        .catch((error) => {
          closeLoader();
          console.log(error);
          toast.error("Failed to regenerate credit score.");
        });
    }
    // eslint-disable-next-line
  }, [otpVerification]);

  const closeCoapplicantDocsModal = () => {
    setCoapplicantDetails({});
    setCoapplicantModal(false);
  };

  const handleDeleteCoapplicant = (coapplicant_id) => {
    let text = "Are you sure you want to delete " + coapplicant_id + "?";
    if (window.confirm(text) === true) {
      openLoader();
      axios
        .post(url + "/coapplicant/delete", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          coapplicant_id: coapplicant_id,
          ip: ip,
          hostname: window.location.hostname,
        })
        .then((res) => {
          if (!res.data.auth) {
            toast.error(res.data.message);
            closeLoader();
            return null;
          }
          // console.log(res);
          toast.success(res.data.message);
          axios
            .post(url + "/borrower/borrowertoalldetails", {
              token: Cookies.get("Token"),
              email: Cookies.get("Email"),
              borrower_uniqueno: localStorage.getItem("uniqueID"),
            })
            .then((res) => {
              updateBorrowerData((prevState) => ({
                ...prevState,
                coapplicant: res.data.message.coapplicant,
              }));
              closeLoader();
            });
        })
        .catch((err) => {
          console.log(err);
          closeLoader();
          return null;
        });
    }
  };

  const verifyCoapplicantDetailsHandler = async (data) => {
    console.log(isDisbursed , !!data.coapplicant_status)
    try {
      const text =
        "Are you sure you want to Verify Co-Applicant " +
        data.coapplicant_id +
        "?";
      if (!window.confirm(text)) {
        toast.error("Coapplicant not verified");
        return null;
      }
      //TODO setLoader(true);
      openLoader();
      const req = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        coapplicant_id: data.coapplicant_id,
      };
      const res = await axios.post(url + "/coapplicant/verified", req);
      if (!res.data.auth) {
        //TODO setLoader(false);
        closeLoader();
        toast.error(res.data.message);
        return null;
      }
      toast.success(res.data.message);
      //TODO setLoader(false);
      closeLoader();
      window.location.reload();
    } catch (err) {
      console.error(err);
      closeLoader();
      return null;
    }
  };

  const handleCreateDuplicateCoapplicant = async (data) => {
    // console.log(data);
    setDuplicateData(data);
    setShowInputBox(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = async () => {
    const createDuplicate = await axios.post(
      url + "/coapplicant/createduplicate",
      {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loanNumber: inputValue,
        duplicateData: duplicateData,
      }
    );
    if (createDuplicate.data.auth === true) {
      toast.success(createDuplicate.data.message);
    } else {
      toast.error(createDuplicate.data.message);
    }
    setShowInputBox(false);
    setInputValue("");
  };

  const handleClose = () => {
    setShowInputBox(false);
  };

  const handleCall = (coapplicant_mobile, coapplicant_id) => {
    const confirmCall = window.confirm("Do you want to call the customer?");
    if (!confirmCall) {
      toast.error("Call cancelled by the user.");
      return;
    }

    if (!vendorCalling) {
      toast.error("Vendor calling info not available.");
      return;
    }

    const uniqueId = uuidv4();
    const payload = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      fromNumber: userMobile,
      toNumber: coapplicant_mobile,
      referenceNumber: uniqueId,
      coapplicant_ID: coapplicant_id,
      customer_Name: userName,
      loan_id: loanid,
    };

    let apiEndpoint = "";

    if (vendorCalling === "Knowlarity") {
      apiEndpoint = url + "/knowlarity/call/api";
    } else if (vendorCalling === "Kalerya") {
      apiEndpoint = url + "/customer/call";
    } else {
      toast.error("Invalid vendor calling configuration.");
      return;
    }

    axios
      .post(apiEndpoint, payload)
      .then((res) => {
        if (res.data.auth) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to initiate call.");
      });
  };

  const handleCreditScore = (data) => {
    openLoader();

    const currentDate = new Date();
    if (!data?.coapplicant_credit_score_180days) {
      console.log(data.coapplicant_mobile);
      handleOtp(data.coapplicant_mobile);
      return;
    }

    //30 days logic
    //  const fetchedDate = new Date(data?.coapplicant_credit_score_fetched_date);
    //  const daysDiff = Math.floor((currentDate - fetchedDate) / (1000 * 60 * 60 * 24));

    //180 days logic
    const fetched180Date = new Date(data?.coapplicant_credit_score_180days);
    const days180Diff = Math.floor(
      (currentDate - fetched180Date) / (1000 * 60 * 60 * 24)
    );

    // console.log(daysDiff, "daysDiff");
    // console.log(days180Diff, "days180Diff");

    if (days180Diff > 180) {
      // console.log("180")
      closeLoader();
      // setstatusModal(true);
      setCoapplicantName(data.coapplicant_name);
      setCoapplicantId(data.coapplicant_id);
      setCoapplicantPhoneNumber(data.coapplicant_mobile);
      handleOtp(data.coapplicant_mobile);
    } else {
      // else if (daysDiff > 30) {
      // console.log("30")
      axios
        .post(url + "/coapplicant/regenerate/credit/score", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          coapplicant_name: data.coapplicant_name,
          coapplicant_mobile: data.coapplicant_mobile,
          coapplicant_panno: data.coapplicant_panno,
          coapplicant_aadharno: data.coapplicant_aadharno,
          coapplicant_voterno: data.coapplicant_voterno,
          coapplicant_dob: data.coapplicant_dob,
          coapplicant_residence_address: data.coapplicant_residence_address,
          coapplicant_pincode: data.coapplicant_pincode,
          coapplicant_locality: data.coapplicant_locality,
          coapplicant_city: data.coapplicant_city,
          coapplicant_state: data.coapplicant_state,
          coapplicant_gender: data.coapplicant_gender,
          coapplicant_id: data.coapplicant_id,
          coapplicant_borrower_uniqueno: data.coapplicant_borrower_uniqueno,
          coapplicant_loan_id: data.coapplicant_loan_id,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth) {
            closeLoader();
            toast.success(res.data.message);
            axios
              .post(url + "/borrower/borrowertoalldetails", {
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
                borrower_uniqueno: localStorage.getItem("uniqueID"),
              })
              .then((res) => {
                updateBorrowerData((prevState) => ({
                  ...prevState,
                  coapplicant: res.data.message.coapplicant,
                }));
              })
              .catch((error) => {
                console.log("Error updating borrower details:", error);
                toast.error("Failed to update borrower details.");
              })
              .finally(() => {
                closeLoader();
              });
          } else {
            closeLoader();
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          closeLoader();
          console.log(error);
          toast.error("Failed to regenerate credit score.");
        });
    }
    // }

    // else {
    //   closeLoader();
    //   // console.log("error reached here")
    //   toast.error("Credit score is within the allowed timeframe and will not be regenerated.");
    // }
  };

  if (statusModal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  console.log(coapplicant, "data");

  const handleChangeCoapplicantPhoneNumber = (e) => {
    if (e.target.value.length <= 10) {
      setCoapplicantPhoneNumber(e.target.value);
    }
    if (e.target.value.length === 10) {
      setTimeout(() => {
        let text = "Send OTP on " + e.target.value + "?";
        if (window.confirm(text) === true) {
          // console.log(e.target.value);
          handleOtp(e.target.value);
        } else {
          toast.error("Please confirm your number for OTP Verification");
          return;
        }
      }, 1000);
    }
  };

  const handleOtp = (phone) => {
    openLoader();
    axios
      .post(url + "/user/lms/otp/send", {
        templateId: "6352612bd6fc0569c5696062",
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrowerMobile: phone,
        VAR1: coapplicantName,
      })
      .then((res) => {
        closeLoader();
        toast.success("OTP Sent to +91 " + phone);
        // console.log(res.data);
        setTimeout(() => {
          const otp = prompt("Please Enter OTP received at +91 " + phone);
          // setOtp(d);
          handleVerify(otp, phone);
        }, 4000);
      })
      .catch((err) => {
        // console.log(err);
        closeLoader();
        toast.error(err.message);
      });
  };

  const handleVerify = (otp, phone) => {
    setOtp(otp);
    axios
      .post(url + "/user/lms/otp/verify", {
        borrowerOtp: otp,
        borrowerMobile: phone,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      })
      .then((res) => {
        if (res.data.type === "success") {
          // console.log(res.data);
          toast.success("OTP Verification Successful");
          setOtpVerification(true);
        } else {
          toast.error("Invalid OTP Please Try Again");
          return;
        }
      })
      .catch((err) => {
        // console.log(err);
        toast.error(err);
      });
  };

  const cancelFunction = () => {
    setstatusModal(false);
    setCoapplicantPhoneNumber("");
  };

  const handleCreateCoapplicant = async (loan) => {
    if (!loan) {
      toast.error("First create a loan");
      return;
    }
    setModalVisible1(true);
    console.log(loan);
    setCurrentLoan(loan.loan_id);

    try {
      const leadsCreated = await axios.post(
        url + "/lead/getCoapplicantLeadsWeb",
        {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
        }
      );

      console.log(leadsCreated.data, "ress");
      if (leadsCreated.data.auth === true) {
        const formatted = leadsCreated.data.message.map((num) => ({
          label: num,
          value: num,
        }));
        setLeadNumbers(formatted);
      } else {
        setLeadNumbers([]);
      }
    } catch (err) {
      setLeadNumbers([]);
      console.log("Error fetching lead numbers:", err);
    }
  };

  const handleConfirmLead = async () => {
    console.log(selectedLead);
    if (!selectedLead) {
      toast.error("Select lead id");
      return;
    }
    console.log(currentLoan);
    setModalVisible1(false);

    try {
      const createCoapplicant = await axios.post(
        url + "/coapplicant/convertFromLead",
        {
          email: Cookies.get("Email"),
          token: Cookies.get("Token"),
          lead_id: selectedLead,
          loan_id: currentLoan,
          identifier: "fromLoan",
        }
      );
      console.log(createCoapplicant.data);
      if (createCoapplicant.data.auth === true) {
        toast.success("Coapplicant created successfully");
        setTimeout(() => {
          window.location.reload();
        }, 4000);
        setSelectedLead(null);
      } else {
        toast.error("Error in creating coapplicant");
        setSelectedLead(null);
      }
    } catch (error) {
      console.error("Error creating coapplicant");
      setSelectedLead(null);
    }
  };

  const handleCloseModal = () => {
    setModalVisible1(false);
    setSelectedLead(null);
  };

  // const handleCreateNew = () => {
  //   console.log('pressed')
  //   navigate('/lead/');
  //   setModalVisible1(false);
  // }

  return (
    <>
      <ToastContainer />
      {coapplicantModal && (
        <CoapplicantDocumentsModal
          closeModal={closeCoapplicantDocsModal}
          coapplicantDetails={coapplicantDetails}
          openLoader={openLoader}
          closeLoader={closeLoader}
          isDisbursed={isDisbursed}
          isDownload={email === "rupesh.bishnoi@credin.in" || permissions.download_co_borrower_document === true}
          isDelete={email === "rupesh.bishnoi@credin.in" || permissions.delete_co_borrower_document === true}
        />
      )}
      {permissions.add_co_borrower && !isDisbursed && (
        <div className={styles.coapplicantButtons}>
          <button
            className={styles.addCoapplicantButton}
            style={{ fontSize: "0.9rem", margin: ".5rem" }}
            onClick={() =>
              // navigate("/coapplicant/add", {
              //   state: {
              //     fetchedBorrowerDetails,
              //     coapplicant,
              //   },
              // })
              handleCreateCoapplicant(latestLoan)
            }
          >
            + Add Co-Applicant
          </button>
        </div>
      )}

      {coapplicant.map((data, index) => {
        return (
          <div className={styles.coapplicantData} key={index}>
            <div className={styles.coapplicantDataContainer}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "flex-end",
                    flexWrap: "wrap",
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: "1rem",
                        color: "gray",
                        fontWeight: "bold",
                      }}
                    >
                      {data.coapplicant_name}
                    </p>
                  </div>
                  <div>
                    <Tooltip title="Call the Customer">
                      <CallIcon
                        style={{ cursor: "pointer", color: "#034ea1" }}
                        onClick={() =>
                          handleCall(
                            data.coapplicant_mobile,
                            data.coapplicant_id
                          )
                        }
                      />
                    </Tooltip>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: "1rem",
                        color: "gray",
                        fontWeight: "bold",
                      }}
                    >
                      Score - {data?.coapplicant_credit_score}
                    </p>
                  </div>
                  <div>
                    <Tooltip
                      title="Regenerate Credit Score"
                      onClick={() => handleCreditScore(data)}
                    >
                      <ReplayIcon
                        style={{ cursor: "pointer", color: "#034ea1" }}
                      />
                    </Tooltip>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  <div>
                    {permissions.edit_co_borrower && !isDisbursed && (
                      <Link to="/coapplicant/edit" state={data}>
                        <BiEdit
                          color="green"
                          title="Edit"
                          cursor="pointer"
                          size={18}
                        />
                      </Link>
                    )}
                  </div>
                  <div>
                    {permissions.view_co_borrower_document ||
                    permissions.download_co_borrower_document ? (
                      <VscNewFolder
                        color="#FF5500"
                        title="View Docs"
                        cursor="pointer"
                        style={{ marginLeft: "1rem" }}
                        size={18}
                        onClick={() => openCoapplicantDocsModal(data)}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {permissions.view_co_borrower && (
                      <Link to="/viewcoapplicantdetails" state={data}>
                        <AiOutlineFolderOpen
                          color="#034ea1"
                          title="View Coapplicant Details"
                          cursor="pointer"
                          style={{
                            marginLeft: "1rem",
                          }}
                          size={18}
                        />
                      </Link>
                    )}
                  </div>

                  <div>
                    {permissions.edit_co_borrower && (
                      <IoIosCopy
                        color="#034ea1"
                        title="Create Duplicate Coapplicant"
                        cursor="pointer"
                        style={{
                          marginLeft: "1rem",
                        }}
                        size={18}
                        onClick={() => handleCreateDuplicateCoapplicant(data)}
                      />
                    )}
                  </div>

                  <Dialog open={showInputBox} onClose={handleClose}>
                    <DialogTitle>Enter Loan Number</DialogTitle>
                    <DialogContent>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Loan Number"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={inputValue}
                        onChange={handleInputChange}
                      />
                      <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" onClick={handleSubmit}>
                          Submit
                        </Button>
                      </DialogActions>
                    </DialogContent>
                  </Dialog>
                  <div>
                    {permissions.delete_co_borrower && !isDisbursed && (
                      <AiOutlineDelete
                        color="red"
                        title="Delete"
                        cursor="pointer"
                        style={{ marginLeft: ".7rem" }}
                        size={18}
                        onClick={() =>
                          handleDeleteCoapplicant(data.coapplicant_id)
                        }
                      />
                    )}
                  </div>

                  {permissions.verify_co_borrower && !isDisbursed && (
                    <>
                      <div>
                        <input
                          type="checkbox"
                          disabled={isDisbursed || !!data.coapplicant_status}
                          onChange={() => verifyCoapplicantDetailsHandler(data)}
                          checked={data.coapplicant_status ? true : false}
                          style={{
                            height: ".9rem",
                            width: ".9rem",
                            marginLeft: ".7rem",
                          }}
                        />
                      </div>

                      <div>
                        <p
                          style={{
                            fontSize: "0.9rem",
                            color: "gray",
                            marginLeft: ".2rem",
                            fontWeight: "bold",
                          }}
                        >
                          Verify
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr
              style={{
                backgroundColor: "gray",
                width: "100%",
                margin: ".2rem 0",
              }}
            />
            <table width="100%" className={styles.myClass}>
              <thead>
                <tr>
                  <th>Loan ID</th>
                  <th>Coapplicant ID</th>
                  <th>Mobile No</th>
                  <th>Email Address</th>
                  {/* <th>Primary Borrower</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{data.coapplicant_loan_id}</td>
                  <td>{data.coapplicant_id}</td>
                  <td>{data.coapplicant_mobile}</td>
                  <td>{data.coapplicant_email}</td>
                  {/* <td>Isha</td> */}
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}

      {statusModal && (
        <div className="modal overlay">
          <div className="status-content">
            <h4 style={{ width: "100%", textAlign: "center" }}>Verification</h4>
            <br />
            <form>
              <div className="lms-table-div-modal">
                <div className="input-div">
                  <label>Mobile Number*</label>
                  <TextField
                    className="lms-input-field"
                    size="small"
                    variant="outlined"
                    id="ph-no"
                    required
                    placeholder="Phone Number"
                    value={coapplicantPhoneNumber}
                    type="number"
                    onChange={handleChangeCoapplicantPhoneNumber}
                    name="ph-no"
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: ".6rem",
                      },
                    }}
                  />
                </div>
                <br />
                <br />
              </div>
              <button
                className="cancel-modal"
                type="button"
                onClick={cancelFunction}
              >
                Close
              </button>
            </form>
          </div>
        </div>
      )}

      {modalVisible1 && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: 20,
              borderRadius: 8,
              width: 400,
              maxWidth: "90%",
            }}
          >
            <h3
              style={{
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: 16,
              }}
            >
              Select lead id which need to be converted to coapplicant
            </h3>

            <select
              value={selectedLead}
              onChange={(e) => setSelectedLead(e.target.value)}
              style={{
                width: "100%",
                padding: 8,
                marginBottom: 20,
                borderRadius: 4,
                border: "1px solid #ccc",
              }}
            >
              <option value="">Select Lead id</option>
              {leadNumbers.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>

            <div
              style={{
                display: "flex",
                gap: 10,
              }}
            >
              <button
                onClick={handleConfirmLead}
                style={{
                  flex: 1,
                  padding: 10,
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              >
                Confirm
              </button>

              {/* <button
                onClick={handleCreateNew}
                style={{
                  flex: 1,
                  padding: 10,
                  backgroundColor: "green",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer"
                }}
              >
                Create New
              </button> */}

              <button
                onClick={handleCloseModal}
                style={{
                  flex: 1,
                  padding: 10,
                  backgroundColor: "#999",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CoapplicantDetails;
